import { useQuery } from '@tanstack/react-query';
import type { HistoricalData } from '@heat-pwa/types';

const API_BASE = import.meta.env.VITE_API_BASE ?? '';

// Bump when the historical data SCHEMA changes. The worker caches
// /api/historical for 1h at the edge, so a fresh URL is the reliable way to
// serve a new schema immediately instead of waiting for the cache to expire.
// v2 = added populations + riskScore; v3 = added per-prefecture station coords;
// v4 = Chiba/Yamaguchi representative fixed to the prefectural capital.
const DATA_SCHEMA = 'v4';

async function fetchHistorical(): Promise<HistoricalData> {
  const res = await fetch(`${API_BASE}/api/historical?schema=${DATA_SCHEMA}`);
  if (!res.ok) throw new Error(`historical fetch failed: ${res.status}`);
  return (await res.json()) as HistoricalData;
}

export function useHistoricalQuery() {
  return useQuery({
    queryKey: ['historical', DATA_SCHEMA],
    queryFn: fetchHistorical,
    staleTime: 24 * 60 * 60 * 1000, // 1 day — historical data is immutable
    gcTime: 7 * 24 * 60 * 60 * 1000,
  });
}
